import { useConsent } from '@/lib/consent';
import { isAmplitudeConfigured } from './client';

/**
 * Whether Amplitude may be used: consent allows non-essential services (off-GDPR or accepted on GDPR) AND Amplitude is configured for this site (env + API key). Reactive via useConsent, so consumers re-render when consent changes post-Accept.
 */
export const useAmplitudeEnabled = (): boolean => {
  const { allowed } = useConsent();
  return allowed && isAmplitudeConfigured();
};
